export default "__VITE_ASSET__55836e56__"